import { create } from 'zustand'

interface TableEditorPosition {
  x: number
  y: number
}

interface TableEditorModalState {
  open: boolean
  tableId: string | null
  createPosition: TableEditorPosition | null
  suggestedName: string
  openCreate: (options?: {
    position?: TableEditorPosition | null
    suggestedName?: string
  }) => void
  openEdit: (tableId: string) => void
  close: () => void
}

export const useTableEditorModal = create<TableEditorModalState>()((set) => ({
  open: false,
  tableId: null,
  createPosition: null,
  suggestedName: '',

  openCreate: (options) =>
    set({
      open: true,
      tableId: null,
      createPosition: options?.position ?? null,
      suggestedName: options?.suggestedName ?? '',
    }),

  openEdit: (tableId) =>
    set({
      open: true,
      tableId,
      createPosition: null,
      suggestedName: '',
    }),

  close: () =>
    set({
      open: false,
      tableId: null,
      createPosition: null,
      suggestedName: '',
    }),
}))
